import { watch } from 'vue'
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { useI18n } from 'vue-i18n'
import { useIntervalFn } from '@vueuse/core'
import { toast } from 'vue-sonner'

const intervalMS = 60 * 60 * 1000

export function usePwaUpdate() {
  const { t } = useI18n({ useScope: 'global' })

  let updateWasPending = false

  const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      if (!r) return
      updateWasPending = !!r.waiting
      useIntervalFn(async () => {
        if (r.installing || !navigator) return
        if ('connection' in navigator && !navigator.onLine) return
        const resp = await fetch(swUrl, {
          cache: 'no-store',
          headers: {
            cache: 'no-store',
            'cache-control': 'no-cache'
          }
        })
        if (resp?.status === 200) await r.update()
      }, intervalMS)
    }
  })

  watch(offlineReady, ready => {
    if (!ready) return
    toast.info(t('pwa.offline'), {
      onDismiss: () => {
        offlineReady.value = false
      }
    })
  })

  // MAJ déjà en attente avant ce chargement (session précédente) : rien à perdre, on active direct.
  // Sinon MAJ détectée en session active (poll périodique) : toast plutôt que reload auto.
  watch(needRefresh, ready => {
    if (!ready) return
    if (updateWasPending) {
      updateServiceWorker(true)
      return
    }
    toast.info(t('pwa.reload-prompt'), {
      duration: Infinity,
      action: {
        label: t('pwa.reload'),
        onClick: () => updateServiceWorker(true)
      },
      onDismiss: () => {
        needRefresh.value = false
      }
    })
  })
}
